/* Footer component */
export default function Footer() {
  return (
    <footer className="App-footer">
      <p>
        © 2025 <a href="http://jean.czerny.fr">Jean Czerny</a>. All rights
        reserved.
      </p>
    </footer>
  );
}
